import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (er) {
      setErr(formatApiErrorDetail(er.response?.data?.detail) || er.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2 border-b border-eduhu-border">
      <div className="hidden lg:flex bg-eduhu-dark text-eduhu-bg grain p-12 flex-col justify-between">
        <div className="font-serif text-6xl text-eduhu-gold leading-none">
          Forgot<br />password?
        </div>
        <div className="text-sm text-eduhu-bg/60 max-w-xs">
          Enter your email and we'll send a secure reset link, valid for 1 hour.
        </div>
      </div>

      <div className="flex items-center justify-center p-8 lg:p-16">
        {sent ? (
          <div className="w-full max-w-md text-center">
            <div className="flex justify-center mb-6">
              <CheckCircle2 size={48} className="text-eduhu-success" />
            </div>
            <h1 className="font-serif text-4xl text-eduhu-dark">Check your email</h1>
            <p className="mt-4 text-eduhu-inkSoft">
              If an account exists for <strong>{email}</strong>, you'll receive a password reset link within a few minutes.
            </p>
            <Link to="/login" className="mt-8 inline-block eduhu-btn-primary">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="w-full max-w-md">
            <div className="flex justify-center mb-8">
              <Link to="/" aria-label="EDUHUB home">
                <img src="/logo.png" alt="EDUHUB logo" className="w-16 h-16 object-contain" />
              </Link>
            </div>

            <div className="overline text-eduhu-claret mb-3">Password reset</div>
            <h1 className="font-serif text-4xl lg:text-5xl text-eduhu-dark tracking-tight">
              Reset your password
            </h1>

            <label className="block mt-10">
              <div className="overline text-eduhu-inkSoft mb-2">Email address</div>
              <input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-eduhu-bg2 border border-eduhu-border px-4 py-3 focus:outline-none focus:border-eduhu-dark"
              />
            </label>

            {err && <div className="mt-4 text-sm text-eduhu-error">{err}</div>}

            <button disabled={busy} className="eduhu-btn-primary w-full justify-center mt-8">
              {busy ? "Sending…" : "Send reset link"}
            </button>

            <div className="mt-6 text-sm text-eduhu-inkSoft text-center">
              <Link to="/login" className="text-eduhu-claret nav-link">
                Back to sign in
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
